export default "__VITE_ASSET__Bjyhqpve__"